<template>
  <card class="ad-listing">
    <el-carousel
      :interval="5000"
      arrow="always"
      indicator-position="none"
      :class="[{ [`carousel-${type}`]: type }]"
    >
      <el-carousel-item v-for="(googleAds, index) in ADS" :key="index">
        <div class="search-box">
          <div class="search-input">
            <p>{{ client.Name }}</p>
            <div class="search-icon">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.714 13.8113C14.8306 13.957 14.918 14.1319 14.918 14.3067C14.918 14.5106 14.8306 14.6854 14.714 14.802L13.8982 15.6178C13.7525 15.7635 13.5777 15.8218 13.4029 15.8218C13.1989 15.8218 13.0241 15.7635 12.9075 15.6178L9.99387 12.7042C9.84819 12.5876 9.78992 12.4128 9.78992 12.2088V11.7426C8.68272 12.6167 7.45898 13.0247 6.06042 13.0247C4.95323 13.0247 3.93345 12.7624 3.00108 12.2088C2.0687 11.6844 1.34029 10.956 0.815826 10.0236C0.26223 9.09121 0 8.07143 0 6.96423C0 5.85704 0.26223 4.8664 0.815826 3.93402C1.34029 3.00165 2.0687 2.27323 3.00108 1.71964C3.93345 1.19518 4.95323 0.903811 6.06042 0.903811C7.16762 0.903811 8.15826 1.19518 9.09064 1.71964C10.023 2.27323 10.7514 3.00165 11.305 3.93402C11.8295 4.8664 12.1208 5.85704 12.1208 6.96423C12.1208 8.36279 11.6838 9.61567 10.8388 10.6937H11.305C11.4798 10.6937 11.6547 10.7811 11.8003 10.8977L14.714 13.8113ZM6.06042 10.6937C6.73057 10.6937 7.34244 10.548 7.92517 10.1984C8.5079 9.8779 8.94495 9.44085 9.29459 8.85812C9.6151 8.27538 9.78992 7.66351 9.78992 6.96423C9.78992 6.29409 9.6151 5.68222 9.29459 5.09949C8.94495 4.51676 8.5079 4.07971 7.92517 3.73007C7.34244 3.40956 6.73057 3.23474 6.06042 3.23474C5.36114 3.23474 4.74927 3.40956 4.16654 3.73007C3.58381 4.07971 3.14676 4.51676 2.82626 5.09949C2.47662 5.68222 2.33093 6.29409 2.33093 6.96423C2.33093 7.66351 2.47662 8.27538 2.82626 8.85812C3.14676 9.44085 3.58381 9.8779 4.16654 10.1984C4.74927 10.548 5.36114 10.6937 6.06042 10.6937Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div class="search-options">
            <ul class="reset">
              <li class="active">Todos</li>
              <li>Videos</li>
              <li>Noticias</li>
              <li>Imágenes</li>
              <li>Maps</li>
            </ul>
          </div>
        </div>
        <div class="search-results">
          <p class="result-title">
            {{
              `${(googleAds || {}).headline1} | ${(googleAds || {}).headline2}`
            }}
          </p>
          <div class="result-url">
            <span>Anuncio</span>
            <p>{{ googleAds.finalUrl.split(".com")[0] }}...</p>
          </div>
          <div class="result-separator"></div>
          <div class="result-description">
            <p>{{ (googleAds || {}).criteria }}</p>
          </div>
        </div>

        <div class="ad-data-copy">
          <div class="data">
            <h5>{{ Number(googleAds.impressions).toLocaleString() }}</h5>
            <p>Impresiones</p>
          </div>
          <div class="data">
            <h5>{{ Number(googleAds.clicks).toLocaleString() }}</h5>
            <p>Clicks</p>
          </div>
          <div class="data">
            <h5>{{ googleAds.ctr }}%</h5>
            <p>CTR</p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </card>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "carousel",
  autoplay: false,
  props: {
    ADS: Array,
    type: String
  },
  data() {
    return {
      adListingsFormat: []
    };
  },
  created: function() {
    const adlistings_1 = [];

    this.adListings &&
      this.adListings.forEach(element => {
        let obj = {
          listingIframeUrl: element
        };
        adlistings_1.push(obj);
      });

    this.adListingsFormat = adlistings_1;
  },
  computed: {
    ...mapState(["client"]),
    ...mapGetters(["products", "currentBusiness", "client", "sidebarIsActive"])
  }
};
</script>
<style lang="scss" scoped>
.ad-listing {
  box-shadow: none !important;
}
.ad-data-copy {
  display: grid;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  grid-template-columns: 1fr 1fr 1fr;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
    p {
      font-size: 12px;
    }
  }
}
.google-box-content {
  > img {
    width: 60px;
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
  }
  .search-box {
    background-color: #fff;
    border-radius: 5px;
    .search-input {
      display: flex;
      justify-content: space-between;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      overflow: hidden;
      box-sizing: border-box;
      p {
        font-size: 12px;
        padding: 8px 0px 8px 15px;
        margin-bottom: 0px;
        align-self: flex-start;
        color: $blueish-gray-700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .search-icon {
        background-color: $google;
        width: 40px;
        height: 36px;
        border-top-right-radius: 5px;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .search-options {
      overflow: hidden;
      padding: 0px;
      margin-top: 5px;

      ul {
        display: flex;
        li {
          padding: 5px 10px;
          color: #c0c0c0;
          text-transform: uppercase;
          font-size: 8px;
          font-weight: $font-medium;
          &.active {
            color: $google;
            border-bottom: 2px solid $google;
          }
        }
      }
    }
  }
  .search-results {
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    box-shadow: $blueShadow;
    border-radius: 5px;
    max-height: 175px;
    .result-title {
      color: $google;
      margin-bottom: 0px;
      font-size: 12px;
      text-align: left;
    }
    .result-url {
      display: flex;
      align-items: baseline;
      span {
        color: #66c18d;
        padding: 0px 2px;
        border: 1px solid #66c18d;
        border-radius: 5px;
        font-size: 10px;
        margin-right: 5px;
      }
      p {
        color: #66c18d;
        font-size: 10px;
        margin-bottom: 7px;
      }
    }
    .result-separator {
      width: 100%;
      height: 1px;
      background: #e0e0e0;
    }
    .result-description {
      p {
        font-size: 10px;
        margin: 5px 0px 0px 0px;
        text-align: left;
      }
    }
  }
}
.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

@include respond-above(ss) {
  .google-box-content {
    max-width: 350px;
    margin: 0 auto;
    > img {
      width: 70px;
    }
    .search-results {
      .result-title {
        font-size: 12px;
      }
      .result-url {
        p {
          font-size: 12px;
        }
      }
      .result-description {
        p {
          font-size: 12px;
        }
      }
    }
  }
}

// @include respond-above(md) {
//   .product-view {
//     display: grid;
//     grid-template: 1fr auto / 1fr minmax(300px, 350px);
//     grid-column-gap: 30px;
//     max-width: 1000px;
//     margin: 0 auto;
//     .widget-look {
//       grid-row: 1 / -1;
//       grid-column: 2;
//     }
//     .widget {
//       &.keyword-widget,
//       &.campaign-widget {
//         grid-column: 1 / -1;
//       }
//     }
//     .separator {
//       grid-column: 1 / -1;
//       margin-bottom: 20px;
//     }
//     .demographic-data {
//       grid-column: 1 / -1;
//       display: grid;
//       grid-template-columns: 1fr 1fr;
//       grid-column-gap: 30px;
//       & > .widget-title {
//         text-align: center;
//         grid-column: 1 / -1;
//         margin-bottom: 30px;
//       }
//       .widget:nth-child(4) {
//         grid-column: 1 / -1;
//       }
//     }
//     .two-column {
//       grid-column: 1 / -1;
//     }
//     .ad-views {
//       grid-column: 1 / -1;
//       .cards-wrapper {
//         display: grid;
//         grid-gap: 30px;
//       }
//     }
//   }
//   .google-box-content {
//     > img {
//       width: 90px;
//     }
//     .search-box {
//       .search-input {
//         p {
//           font-size: 14px;
//         }
//       }
//       .search-options {
//         ul {
//           li {
//             font-size: 10px;
//             padding: 7px 15px;
//           }
//         }
//       }
//     }
//     .search-results {
//       max-height: 145px;
//       .result-title {
//         font-size: 14px;
//       }
//     }
//   }
// }

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }

  .ad-views {
    grid-column: 1 / -1;
    .ad-listing {
      padding: 0;
    }
  }
  .cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

@include respond-above(sm) {
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
